module.exports = __webpack_public_path__ + "img/search.1b0da7d.png";